import React, { useState, useEffect } from "react";
import jwtDecode from "jwt-decode";
import moment from "moment";
import * as XLSX from "xlsx-js-style";
import { FiEye, FiEdit, FiTrash2 } from "react-icons/fi";


import CustomTable from "../../../components/table/table";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import { user_company_list, super_comp_delete } from "../admin.api";
import {
  createdFromAdmin,
  statusRegTypeExisting,
} from "../../../components/table/store";
import "./view.css";

const getStatusInfo = (status) => {
  const statusMap = {
    0: { label: "Pending", class: "pending", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
    1: { label: "Submitted", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg> },
    2: { label: "Accepted", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
    3: { label: "SA Reverted", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> },
    4: { label: "Rejected", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> },
    5: { label: "Reverted", class: "danger", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 8v4m0 4h.01"></path></svg> },
    // 6: { label: "Agreement", class: "info", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> },
    // 7: { label: "Ongoing", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg> },
    // 8: { label: "Completed", class: "successs", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> },
  };
  return statusMap[status] || { label: "Unknown", class: "secondary", icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> };
};

export default function View(props) {
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(9);
  const [createdFrom, setCreateFrom] = useState(99);
  const [companyName, setCompanyName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [showFilters, setShowFilters] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const handleListData = () => {
    setIsActive(true);
    let param = {
      type: "kerala",
      status: status === 9 ? "" : status,
      isadmin: createdFrom === 99 ? "" : createdFrom,
      company_name: companyName,
      page: page,
      per_page: perPage,
    };
    user_company_list(param, adminType).then((resp) => {
      // Handle different API response structures (res.data vs res as array)
      const rawData = resp?.data || (Array.isArray(resp) ? resp : []);

      if (rawData && Array.isArray(rawData)) {
        rawData.forEach((item, index) => {
          item["slno"] = perPage === "all" ? index + 1 : (page - 1) * perPage + index + 1;
        });
        setData(rawData);

        // Handle pagination from root or nested object
        const lastPage = resp?.last_page || resp?.pagination?.last_page || 1;
        setTotalPages(lastPage);
      } else {
        setData([]);
      }
      setIsActive(false);
    }).catch(() => {
      setData([]);
      setIsActive(false);
    });
  };

  useEffect(() => {
    handleListData();
  }, [page, perPage, status, createdFrom, companyName]);

  const handleEdit = (data) => {
    props.history.push("/edit-application-kerala/" + data.id);
  };

  const handleView = (data) => {
    props.history.push("/view-application-kerala/" + data.id);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    super_comp_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
        handleListData();
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleListData();
    }
  };

  const handleNew = () => {
    props.history.push("/newrequest-application-kerala");
  };

  const handleBulkEmail = () => {
    props.history.push("/bulk-email-kerala");
  };

  const handleChangeStatus = (e) => {
    setStatus(Number(e.target.value));
    setPage(1);
  };

  const handleCreatedFrom = (e) => {
    setCreateFrom(Number(e.target.value));
    setPage(1);
  };

  const handlePerPageChange = (e) => {
    setPerPage(e.target.value);
    setPage(1);
  };

  const genDomain = (item) => {
    let domainStr = (item?.domain_types || []).map(d => d.domain_name).join(", ");
    if (item?.any_other_domain && item.any_other_domain !== "null") {
      if (domainStr) domainStr += ", " + item.any_other_domain;
      else domainStr = item.any_other_domain;
    }
    return domainStr || "";
  };

  const cleanVal = (val) => {
    if (val === null || val === undefined || val === "null" || String(val).trim() === "") {
      return "";
    }
    return String(val).trim();
  };

  const downloadExcel = async () => {
    setIsDownloading(true);
    try {
      // Small delay to ensure loading state is visible
      await new Promise(resolve => setTimeout(resolve, 500));
      const exportData = await fetchExportData();
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Style cells and format header with blue bg, white text, bold, and center alignment
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const address = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[address]) continue;

          if (R === 0) {
            // Header: bold, white text, blue background, center aligned
            worksheet[address].s = {
              font: {
                bold: true,
                color: { rgb: "FFFFFF" },
                sz: 11,
                name: "Arial"
              },
              fill: {
                fgColor: { rgb: "1F4E78" } // Premium Blue Background
              },
              alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true
              },
              border: {
                top: { style: "thin", color: { rgb: "D3D3D3" } },
                bottom: { style: "medium", color: { rgb: "1F4E78" } },
                left: { style: "thin", color: { rgb: "D3D3D3" } },
                right: { style: "thin", color: { rgb: "D3D3D3" } }
              }
            };
          } else {
            // Data cells
            worksheet[address].s = {
              font: {
                sz: 10,
                name: "Arial"
              },
              alignment: {
                horizontal: C === 0 ? "center" : "left", // Center Sl No
                vertical: "center"
              },
              border: {
                top: { style: "thin", color: { rgb: "E5E5E5" } },
                bottom: { style: "thin", color: { rgb: "E5E5E5" } },
                left: { style: "thin", color: { rgb: "E5E5E5" } },
                right: { style: "thin", color: { rgb: "E5E5E5" } }
              }
            };
          }
        }
      }

      // Auto-fit column widths to make a formatted excel view
      const colWidths = Object.keys(exportData[0] || {}).map(key => {
        const headerLen = key.length;
        const maxCellLen = Math.max(
          ...exportData.map(row => String(row[key] || '').length)
        );
        return {
          wch: Math.max(headerLen, maxCellLen) + 3 // add padding so text is not truncated
        };
      });
      worksheet['!cols'] = colWidths;

      // Set header row height to be taller for better presentation
      worksheet['!rows'] = [
        { hpt: 24 } // height in points
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Companies");
      XLSX.writeFile(workbook, "Companies-Kerala.xlsx");
    } catch (error) {
      console.error("Error downloading Excel:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  async function fetchExportData() {
    const exportdata = [];
    data.forEach((item, index) => {
      exportdata.push({
        ["Sl No"]: index + 1,
        ["Company Name"]: cleanVal(item.company_name),
        ["Company Domain"]: genDomain(item),
        ["Company Address"]: cleanVal(item.address),
        ["POC"]: cleanVal(item.person_name),
        ["POC Designation"]: cleanVal(item.person_designation),
        ["Phone Number"]: cleanVal(item.phone_no),
        ["Email Id"]: cleanVal(item.email),
        ["Alternate Phone Number"]: cleanVal(item.alternate_phone),
        ["Alternate Email Id"]: cleanVal(item.alternate_email),
        ["Website Link"]: cleanVal(item.site_link),
      });
    });
    return exportdata;
  }

  const renderPagination = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      pages.push(
        <button key={1} className="btn btn-outline-primary" style={{ fontSize: "13px" }} onClick={() => setPage(1)}>1</button>
      );
      if (start > 2) pages.push(<span key="start-dots" className="px-1 text-primary">...</span>);
    }

    for (let i = start; i <= end; i++) {
      pages.push(
        <button
          key={i}
          className={`btn ${page === i ? "btn-primary text-white" : "btn-outline-primary"}`}
          style={{ fontSize: "13px" }}
          onClick={() => setPage(i)}
        >
          {i}
        </button>
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1) pages.push(<span key="end-dots" className="px-1 text-primary">...</span>);
      pages.push(
        <button key={totalPages} className="btn btn-outline-primary" style={{ fontSize: "13px" }} onClick={() => setPage(totalPages)}>{totalPages}</button>
      );
    }

    return pages;
  };

  return (
    <>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
      <div className="container-fluid mt-4">
        <Loader open={isActive} />
        <Snackbar message={snackMessage} error={isSnackError} open={snackOpen} close={snackbarClose} />

        <div className="card shadow-sm">
          <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              <b>Companies in Kerala</b>
            </h5>
            <div className="d-flex gap-2">
              {adminType === 1 && (
                <button className="btn btn-primary btn-sm" onClick={handleNew}>
                  Add New Company
                </button>
              )}
              {data?.length !== 0 && adminType !== 2 && (
                <button className="btn btn-primary btn-sm" onClick={handleBulkEmail}>
                  Bulk Email
                </button>
              )}
              <button className="btn btn-primary btn-sm" onClick={downloadExcel} disabled={isDownloading}>
                {isDownloading ? (
                  <>
                    <svg className="me-2" style={{ width: "1.2rem", height: "1.2rem", animation: "spin 1s linear infinite" }} viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" strokeOpacity="0.25" />
                      <path d="M12 2C6.48 2 2 6.48 2 12" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
                    </svg>
                    Downloading...
                  </>
                ) : (
                  "Download Excel"
                )}
              </button>
              <button
                className={`filter-icon-btn ${showFilters ? "active" : ""}`}
                onClick={() => setShowFilters(!showFilters)}
                title="Toggle Filters"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                </svg>
              </button>
            </div>
          </div>

          <div className="card-body pt-0">
            <div className={`filter-container ${showFilters ? "show" : ""}`}>
              <div className="row align-items-end">
                <div className="col-md-3">
                  <label className="form-label small">Company Name</label>
                  <input
                    type="text"
                    className="form-control filter-select"
                    placeholder="Search company..."
                    value={companyName}
                    onChange={(e) => {
                      setCompanyName(e.target.value);
                      setPage(1);
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label small">Status</label>
                  <select className="form-control filter-select" value={status} onChange={handleChangeStatus}>
                    <option value={9}>All Statuses</option>
                    {statusRegTypeExisting.map((item) => (
                      item.id !== 6 && <option key={item.id} value={item.id}>{item.title}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label small">Created From</label>
                  <select className="form-control filter-select" value={createdFrom} onChange={handleCreatedFrom}>
                    {createdFromAdmin.map((ite) => (
                      <option key={ite.id} value={ite.id}>{ite.title}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3 d-flex gap-2">
                  <button
                    className="filter-action-btn"
                    title="Reset Filters"
                    onClick={() => {
                      setStatus(9);
                      setCreateFrom(99);
                      setCompanyName("");
                      setPage(1);
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                      <path d="M3 3v5h5"></path>
                    </svg>
                  </button>
                  <button className="filter-action-btn close-btn" title="Close Filters" onClick={() => setShowFilters(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-light rounded border" style={{ fontSize: "14px" }}>
              <div className="d-flex align-items-center gap-3">
                <span className="text-muted fw-semibold">
                  Showing <span className="text-dark fw-bold">{data.length}</span> of <span className="text-dark fw-bold">{perPage === "all" ? data.length : totalPages * Number(perPage)}</span> records
                </span>
                <span className="badge bg-primary" style={{ fontSize: "13px", padding: "6px 12px" }}>
                  Page {page} of {totalPages}
                </span>
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                  <label className="text-muted fw-semibold mb-0" style={{ fontSize: "13px" }}>Rows per page:</label>
                  <select className="form-select form-select-sm" value={perPage} onChange={handlePerPageChange} style={{ fontSize: "13px", height: "36px", width: "80px" }}>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="all">All</option>
                  </select>
                </div>
                <div className="btn-group">
                  <button className="btn btn-outline-primary" disabled={page === 1} onClick={() => setPage((p) => p - 1)} style={{ fontSize: "13px" }}>Prev</button>
                  {renderPagination()}
                  <button className="btn btn-outline-primary" disabled={page === totalPages} onClick={() => setPage((p) => p + 1)} style={{ fontSize: "13px" }}>Next</button>
                </div>
              </div>
            </div>

            <CustomTable
              {...props}
              columns={[
                { title: "Sl No", field: "slno", style: { width: "70px", maxWidth: "70px" } },
                { title: "Company Name", field: "company_name" },
                { title: "Application ID", field: "unique_application_ref_no" },
                { title: "Phone Number", field: "phone_no" },
                { title: "Email", field: "email" },
                {
                  title: "Status",
                  field: "project_status",
                  render: (row) => {
                    const statusInfo = getStatusInfo(row.project_status ?? row.application_status);
                    return (
                      <span className={`status-badge ${statusInfo.class}`}>
                        <span className="status-icon">{statusInfo.icon}</span>
                        <span className="status-label">{statusInfo.label}</span>
                      </span>
                    );
                  },
                },
                {
                  title: "Action",
                  render: (row) => (
                    <div className="d-flex gap-1">
                      <button
                        className="btn btn-sm btn-outline-primary action-btn"
                        onClick={() => handleView(row)}
                        title="View"
                      >
                        <FiEye size={16} />
                      </button>
                      {adminType === 1 && (
                        <button
                          className="btn btn-sm btn-outline-secondary action-btn"
                          onClick={() => handleEdit(row)}
                          title="Edit"
                        >
                          <FiEdit size={16} />
                        </button>
                      )}
                      {adminType === 2 && (
                        <>
                          <button
                            className="btn btn-sm btn-outline-secondary action-btn"
                            onClick={() => handleEdit(row)}
                            title="Edit"
                          >
                            <FiEdit size={16} />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger action-btn"
                            onClick={() => handleDelete(row)}
                            title="Delete"
                          >
                            <FiTrash2 size={16} />
                          </button>
                        </>
                      )}
                    </div>
                  ),
                },
              ]}
              data={data}
              paging={false}
              options={{
                search: true,
                selection: false,
                exportButton: false,
              }}
            />
          </div>

          {openAction && (
            <ConfirmDialog
              open={openAction}
              title="Delete Company?"
              data={activeData}
              message="Are you sure you want to delete this company?"
              secondary_action="Cancel"
              primary_action="Delete"
              handleClose={handleCancelDelete}
              handleConfirm={handleDeleteConfirm}
            />
          )}
        </div>
      </div>
    </>
  );
}
